import { useContext, useEffect } from "react";

import { ColSize, RowSize } from "../../../shared/components"
import { InfoContext } from "../../../shared/contexts";

import { PageHeader } from "../../../shared/components/MainLayout/components";

import { SavedAndSentPreLiquidationsProvider } from "./shared/contexts/SavedAndSentPreLiquidations";
import { PreLiquidationsTabs } from "./shared/components";

export const SavedAndSentPreLiquidationsContent = () => {
    const { setTitle } = useContext(InfoContext);

    useEffect(() => {
        setTitle('Preliquidaciones Enviadas y Guardadas');
        /* eslint-disable-next-line */
    }, []);

    return (
        <RowSize>
            <ColSize size={100}>
                <PageHeader />
            </ColSize>

            <ColSize size={100}>
                <PreLiquidationsTabs />
            </ColSize>
        </RowSize>
    )
};

export const SavedAndSentPreLiquidationsPage = () => (
    <SavedAndSentPreLiquidationsProvider>
        <SavedAndSentPreLiquidationsContent />
    </SavedAndSentPreLiquidationsProvider>
);

